import {
  logisticsSearchPlayer,
  searchOnlyPlayers,
  searchPlayers,
} from 'src/graphql/queries/players.graphql';
import type {
  ISearchPlayerQuery,
  ISearchPlayerQueryVariables,
} from 'src/graphql/queries/players.graphql.types';
import type { IOrganizationRoleEnum } from 'src/graphql/types';
import { useQuery } from 'urql';

const useSearchPlayers = ({
  query,
  playersOnly,
  accessLevelFilters,
  branchId,
  eventId,
  modId,
  branchIds,
  activeFrom,
  activeUpto,
  activeInversion,
  withCorrectiveActions,
  pause = false,
  strictlyPlayersOnly,
  logistics = false,
}: {
  query: string;
  playersOnly?: boolean;
  accessLevelFilters?: IOrganizationRoleEnum[];
  branchId?: number;
  eventId?: number;
  modId?: number;
  branchIds?: number[];
  activeFrom?: string;
  activeUpto?: string;
  activeInversion?: boolean;
  withCorrectiveActions?: boolean;
  pause?: boolean;
  strictlyPlayersOnly?: boolean;
  logistics?: boolean;
}) => {
  const [{ data, error, fetching, stale }, executeSearch] = useQuery<
    ISearchPlayerQuery,
    ISearchPlayerQueryVariables
  >({
    query: logistics
      ? logisticsSearchPlayer
      : strictlyPlayersOnly
        ? searchOnlyPlayers
        : searchPlayers,
    variables: {
      query,
      playersOnly,
      accessLevelFilters,
      branchId,
      branchIds,
      eventId,
      modId,
      activeFrom,
      activeUpto,
      activeInversion,
      withCorrectiveActions,
    },
    requestPolicy: 'network-only',
    pause: pause || query.trim().length < 1,
  });

  return { data, error, fetching, stale, executeSearch };
};

export default useSearchPlayers;
